package com.loyola.acessoescola.ui.login

import acessoescola.composeapp.generated.resources.Res
import acessoescola.composeapp.generated.resources.login
import acessoescola.composeapp.generated.resources.microsoft_color
import acessoescola.composeapp.generated.resources.policy_notice
import acessoescola.composeapp.generated.resources.privacy_policy
import androidx.compose.foundation.Image
import androidx.compose.foundation.clickable
import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextDecoration
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import com.loyola.acessoescola.services.AppRoleException
import com.loyola.acessoescola.ui.components.ErrorDialog
import com.loyola.acessoescola.ui.theme.AcessoEscolaTheme
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource


fun Color.Companion.lightBlue(): Color {
    return Color(
        red = 51f/255f,
        green = 154f/255f,
        blue = 234f/255f,
    )
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun LoginScreen(
    paddingValues: PaddingValues,
    viewModel: LoginViewModel,
    navToRegistered: () -> Unit,
    navToPolicy: () -> Unit,
    navToAdminPanel: () -> Unit
){

    var errorMessage by remember { mutableStateOf("") }
    val darkTheme = isSystemInDarkTheme()

    if (errorMessage != "") {
        ErrorDialog(
            errorMessage = errorMessage,
            onErrorMessageChange = { errorMessage = it }
        )
    }

    Scaffold(modifier = Modifier.padding(paddingValues)){ paddingValues ->
        Column(
            modifier = Modifier.padding(paddingValues)
                .fillMaxSize(),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center
        ) {

            IconButton(
                onClick = {
                    viewModel.authClientSign(
                        onSuccessCallBack = { appRoles ->
                            if (AppRoles.ALUNO.appRole in appRoles) {
                                navToRegistered()
                            } else if (AppRoles.ADMIN.appRole in appRoles) {
                                navToAdminPanel()
                            } else {
                                throw AppRoleException("Função não definida para o App")
                            }
                        },
                        onErrorCallBack = { errorMessage = it}
                    )
                },
                modifier = Modifier.size(128.dp)
            ) {
                Image(
                    painter = painterResource(Res.drawable.microsoft_color),
                    contentDescription = stringResource(Res.string.login),
                    modifier = Modifier.fillMaxSize().padding(all=16.dp)
                )
            }
            Text(
                text = stringResource(Res.string.login),
            )
            FlowRow(
                horizontalArrangement = Arrangement.Center,
                modifier = Modifier.padding(top=64.dp)
            ) {
                Text(
                    text = stringResource(Res.string.policy_notice),
                    style = MaterialTheme.typography.labelSmall
                )
                Text(
                    text = stringResource(Res.string.privacy_policy),
                    style = MaterialTheme.typography.labelSmall,
                    color = if (darkTheme) Color.lightBlue() else Color.Blue,
                    textDecoration = TextDecoration.Underline,
                    modifier = Modifier.clickable(onClick = {navToPolicy()})
                )
            }
        }
    }
}

@Preview
@Composable
private fun LoginScreenPreview(){
    AcessoEscolaTheme {
//        LoginScreen()
    }
}

